import React, { useState, useEffect } from "react";

import { Link, useNavigate } from "react-router-dom";
import { requestLoginPost } from "utils/AxiosApi";
import "style/style.css";
import MsgModal from "modals/MsgModal";
import { getCookies, rmCookie, setCookies } from "utils/Util";

const medmall_header = "/img/medmall_header.png";

const Login = () => {
  let history = useNavigate();

  //모달창 open
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMsg, setModalMsg] = useState("");

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailSave, setEamilSave] = useState(false);
  const handleInputEmail = (e: any) => {
    setEmail(e.target.value);
  };

  const handleInputPw = (e: any) => {
    setPassword(e.target.value);
  };
  const saveBtnClick = () => {
    if (emailSave) {
      setEamilSave(false);
    } else {
      setEamilSave(true);
    }
  };

  const rememberId = () => {
    const expires = new Date();
    expires.setDate(expires.getDate() + 30);
    setCookies("save_id", email, {
      path: "/",
      sameSite: "strict",
      expires,
    });
  };

  const tryLogin = async () => {
    let data = await requestLoginPost("/api/login", {
      id: email,
      password: password,
    });

    if (data.result === true) {
      if (emailSave) {
        rememberId();
      }
      if (data.sts !== "R") {
        history("/main");
        // window.location = data.url;
      } else {
        setModalOpen(true);
        setModalMsg("가입 승인 대기 중인 계정입니다.");
      }
    } else if (data.result === false) {
      setModalOpen(true);
      setModalMsg("아이디와 비밀번호를 확인해주세요");
    }
  };

  const onKeyPress = (e: any) => {
    if (e.key === "Enter") {
      tryLogin();
    }
  };

  const modalConfirm = () => {
    setModalOpen(false);
  };

  const getCookieEmailId = () => {
    let savedId = getCookies("save_id");
    if (savedId !== undefined) {
      setEmail(savedId);
      setEamilSave(true);
    }
  };

  useEffect(() => {
    getCookieEmailId();
    rmCookie();
  }, []);

  return (
    <div>
      <div className="display-center">
        <div className="title">
          <div className="title_logo_img">
            <img src={medmall_header} alt="medmall_header_logo"></img>
            {/* <span className="span-blue-40" id="font-SCD7">
              로그인
            </span> */}
          </div>
        </div>
        <br></br>
        <div style={{ marginTop: "30px", marginBottom: "-20px" }}>
          <div className="span-gray-text">
            <span id="font-SCD5">아이디</span>
            <input
              className="input-form-w97p"
              type="text"
              name="email"
              value={email}
              onChange={handleInputEmail}
              onKeyPress={onKeyPress}
            ></input>
          </div>
          <div className="span-gray-text">
            <span id="font-SCD5">비밀번호</span>
            <input
              className="input-form-w97p"
              type="password"
              name="password"
              value={password}
              onChange={handleInputPw}
              onKeyPress={onKeyPress}
            ></input>
          </div>
        </div>
        <div className="checkbox-right">
          <input
            className="ckeckbox-1"
            type="checkbox"
            value="true"
            checked={emailSave}
            onChange={saveBtnClick}
          ></input>
          <label id="font-SCD4" onClick={saveBtnClick}>
            아이디저장
          </label>
        </div>
        <div style={{ clear: "both" }}></div>
        <div className="login-action">
          <div>
            <Link to="/find/account">
              <span className="span-gray-pointer" id="font-SCD4">
                아이디 또는 비밀번호를 분실하셨나요?
              </span>
            </Link>
          </div>
          <br />
          <div style={{ marginTop: "30px" }}>
            <div className="margin-bottom-40">
              <button
                className="btn-blue-w130"
                type="button"
                onClick={tryLogin}
                id="font-SCD7"
              >
                로그인
              </button>
            </div>
            <hr style={{ margin: "30px 0" }}></hr>
            <div className="margin-top-40">
              <Link to="/join">
                <button className="btn-blue-w130" type="button" id="font-SCD7">
                  회원가입
                </button>
              </Link>
            </div>
            <br />
            <br />
          </div>
        </div>
      </div>
      {modalOpen && (
        <MsgModal
          setOpenModal={setModalOpen}
          modalMsg={modalMsg}
          modalConfirm={modalConfirm}
        ></MsgModal>
      )}
    </div>
  );
};

export default Login;
